module.exports = __webpack_public_path__ + "static/media/render-front-aerial-view.b0d7f397.png";